import { useState, useEffect, useCallback } from 'react';
export var useCommentSuggestions = function (editorApi, editorState) {
    var _a = useState(), commentSuggestion = _a[0], setCommentSuggestion = _a[1];
    var isEditorEmpty = !editorState || editorState.isEmpty;
    /*
     ** Don't let user submit if:
     ** - editor is blank
     ** - they've selected a suggestion and haven't added any text
     */
    var submitValidator = useCallback(function (newState) {
        var editorText = newState.editorContent.getPlainText();
        return (!newState.isEmpty &&
            (!commentSuggestion || editorText !== commentSuggestion));
    }, [commentSuggestion]);
    // When suggestion is selected, reset editor with its content, making sure editor has been loaded
    useEffect(function () {
        if (commentSuggestion && editorApi) {
            // Even after the editor is "ready" we need to wait until editorState has been refreshed
            setTimeout(function () {
                editorApi.clearEditor(true, commentSuggestion);
            }, 10);
        }
    }, [editorApi, commentSuggestion]);
    // When editor content is cleared, we also clear the currently selected suggestion if there's any
    useEffect(function () {
        isEditorEmpty && setCommentSuggestion(undefined);
    }, [isEditorEmpty]);
    var onSuggestionSelect = function (suggestion) {
        return setCommentSuggestion(suggestion);
    };
    return {
        // if editor is unloaded and user selected a suggestion, force load
        forceEditorLoad: !editorApi && Boolean(commentSuggestion),
        submitValidator: submitValidator,
        onSuggestionSelect: onSuggestionSelect,
    };
};
//# sourceMappingURL=useCommentSuggestions.js.map